import "./PageLoadingOverlay.html";
import "./PageLoadingOverlay.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
// import PageLoadingOverlayComponentController from "./PageLoadingOverlayComponentController";

export class PageLoadingOverlayComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        // this.controller = PageLoadingOverlayComponentController;
        this.templateUrl = "/App/Modules/Gui/Components/PageLoadingOverlay/PageLoadingOverlay.html";
    }
}
